import PanoInfo from '../../components/panoInfo';
function showPanoinfo() {
  if (!this.params.configPanoInfo) return;
  const showFooter = this.params.auther.is_vip || this.params.configPanoInfo.project_vip ? 0 : 1;
  //显示全景简介
  new PanoInfo({
    wrapper: this.$container.get(0),
    closeBtn: false,
    article: {
      ...this.params.configPanoInfo,
    },
    showFooter,
  });
}
export default showPanoinfo;